module.exports = __webpack_public_path__ + "static/media/arrow-right.10e237e7.svg";